import React from 'react';
import styled from 'styles/styled';

interface ProgressBarProps {
  currentStep: 'payment' | 'verification' | 'game';
}

const steps = [
  { key: 'payment', label: 'Payment' },
  { key: 'verification', label: 'Payment verification' },
  { key: 'game', label: 'Game' },
];

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
  const currentIndex = steps.findIndex((step) => step.key === currentStep);
  // 0 -> 0%, 1 -> 50%, 2 -> 100%
  const progress = currentIndex * 50;

  return (
    <Wrapper>
      <LabelsRow>
        {steps.map((step, index) => (
          <Label key={step.key} $active={index === currentIndex}>
            {step.label}
          </Label>
        ))}
      </LabelsRow>
      <LineWrapper>
        <BaseLine $progress={progress} />
        <DotsRow>
          {steps.map((step, index) => (
            <Dot
              key={step.key}
              $active={index <= currentIndex}
            />
          ))}
        </DotsRow>
      </LineWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin: 12px 0 4px;
`;

const LabelsRow = styled.div`
  display: flex;
  justify-content: space-between;
  width: 274px;
  max-width: 100%;
`;

const Label = styled.span<{ $active: boolean }>`
  font-size: 12px;
  color: ${(props) => (props.$active ? '#52D381' : '#EFEFEF')};
  font-weight: 500;
  white-space: nowrap;

  @media (max-width: 720px) {
    font-size: 11px;
  }
`;

const LineWrapper = styled.div`
  position: relative;
  width: 274px;
  max-width: 100%;
  height: 12px;
`;

const BaseLine = styled.div<{ $progress: number }>`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background: ${({ $progress }) =>
    `linear-gradient(to right, #52D381 ${$progress}%, #EFEFEF ${$progress}%)`};
  transform: translateY(-50%);
`;

const DotsRow = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transform: translateY(-50%);
`;

const Dot = styled.div<{ $active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => (props.$active ? '#52D381' : '#EFEFEF')};
`;

export default ProgressBar;
